// extracted by mini-css-extract-plugin
export default {"layout":"SidebarLayout_layout__2-d5P","hideSidebar":"SidebarLayout_hideSidebar__98MqT","likeAnimation":"SidebarLayout_likeAnimation__zNILW"};